(function () {
    // 注册组件
    SR.component.extend('externalContainer', externalContainer);

    function externalContainer() {
        this.create = function (option) {
            var $answer = $('#' + option.answerDomId);
            var $loading = $answer.find('.loading');
            var $externalWrap = $answer.find('.external');
            var loadingTimer;
            var loadingStatus;
            var timeout = 3000;
            var $content;

            loadingTimer = setTimeout(function () {
                loadingStatus = 'timeout';
                errorHandler('load timeout (' + timeout + ')ms');
            }, timeout);

            // iframe 模式
            if (option.contentType === 'html') {
                var url = option.api;
                var connector = url.indexOf('?') !== -1 ? '&' : '?';
                if (SR.state.customMulitParams && SR.data.mulitParams) {
                    url += connector + 'srmp=' + SR.data.mulitParams + '&t=' + Date.now();
                } else {
                    url += connector + 't=' + Date.now();  // 添加时间戳，防止缓存
                }
                var $content = $('<iframe src="'+ url +'" class="external-iframe" scrolling="'+ scroll +'" frameborder="0"></iframe>');
                $externalWrap.append($content);

                $content.on('load', function (e) {
                    if (loadingStatus === 'timeout') {
                        return;
                    }
                    clearTimeout(loadingTimer);
                    try {
                        var externalDoc = this.contentDocument || this.contentWindow.document;
                        var $externalDoc = $(externalDoc);
                        var $container = $externalDoc.find('.sr-external-container');
                        if (!$container.length) {
                            errorHandler('debug: cannot find .sr-external-container dom');
                        }
                        var externalOption = this.contentWindow.window.SRExternalOption || {};
                        var scroll = externalOption.scroll ? 'scroll' : 'no';
                        this.contentWindow.srData = {};
                        $externalWrap.removeClass('sr-hide');
                        $content.attr('scrolling', scroll);
                        setTimeout(function() {
                            var containerH = externalOption.contentHeight || $container.height();
                            $content.height(containerH);
                            // debug info
                            if (externalOption.debug) {
                                console.log('debug: get external option =>', externalOption);
                                console.log('debug: container height =>', containerH);
                            }
                            // 回调
                            setExternalOption(externalOption);
                            option.success && option.success(option);
                            $loading.remove();
                        }, 10);
                    } catch (err) {
                        errorHandler(err);
                    }
                });

                function setExternalOption(externalOption) {
                    try {
                        externalOption.onLoad && externalOption.onLoad();
                    } catch (err) {
                        externalOption.debug && console.warn('debug: external onLoad callback has error =>', err);
                    }
                    if (externalOption.noTitle) {
                        $externalWrap.removeClass('simple-title');
                    }
                }
            // 图片模式
            } else if (option.contentType === 'img') {
                if (!option.img) {
                    errorHandler();
                }
                var url = option.img;
                var params = '';
                var $img = $('<img src='+ option.img +' class="external-img" />');
                var $title = $answer.find('.sr-title');
                var $link = $img;
                if (option.api) {
                    $link = $('<a href="#;" class="J_invokeAppEvent" data-params=\'{"action": "viewInWebview", "url": "'+ option.api +'"}\'></a>').append($img);
                }
                $externalWrap.append($link);
                $img.on('load', function (e) {
                    if (loadingStatus === 'timeout') {
                        return;
                    }
                    clearTimeout(loadingTimer);
                    option.success && option.success(option);
                    $loading.remove();
                    $title.removeClass('sr-hide');
                    $externalWrap.removeClass('sr-hide');
                });
            }

            function errorHandler(err) {
                $content.remove();
                $loading.remove();
                $externalWrap.removeClass('simple-title external sr-hide').addClass('error').append('加载错误，请重试');
                option.error && option.error(option);
                err && console.warn('debug: external load error =>', err);
            }
        }
    }
}());